import React from 'react'

const Tokenomics = () => {
  return (
    <div className='min-h-[80vh] w-[100vw] flex flex-col justify-center items-center bg1 text-white'>
        <p className='text-center text-[52px] md:text-[98px] text-black font1'>
            Tokenomics
        </p>
        <div className='bg-[#222] font1 rounded-md py-4 md:py-8 px-6 md:px-12 font1 font-bold tracking-[2px] border-[4px] rounded-[20px] text-white text-center '>
            <p  className='text-[15px] md:text-[56px] mb-6 mt-8'>CA: CYdZszyRqn5C9wiSrEvh9cZgeo3UeWb1mj1HiNBppump</p>
            <p  className='text-[28px] md:text-[56px] mb-6'>Liquidity Burned</p>
            <p  className='text-[20px] md:text-[46px] mb-6'>Renounced</p>
            <p className='text-[20px] md:text-[56px] mb-6'>Supply : 1 Billion</p>
        </div>
        <p className='text-center text-[16px] md:text-[22px] text-black font1 mt-8'>
            Note: that this coin offers no intrinsitc value and is just a printor.
        </p>
    </div>
  )
}

export default Tokenomics